export default __webpack_public_path__ + "static/2-6c7c8434728bdc70a93668bc8455be4e.jpg";